import { AfterViewInit, Component, ElementRef, Inject, PLATFORM_ID, QueryList, ViewChildren } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

interface Industry {
  image: string;
  title: string;
  description: string;
  color: string;
}

@Component({
  selector: 'app-business-industries',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './business-industries.html',
  styleUrl: './business-industries.css',
})
export class BusinessIndustriesComponent implements AfterViewInit {
  readonly industries: Industry[] = [
    {
      image: 'images/mobilizers/pos.png',
      title: 'Retail & POS',
      description: 'Ring up sales, track stock, and manage every till from one connected system.',
      color: '#009ebf',
    },
    {
      image: 'images/webps/manufacturing.svg',
      title: 'Manufacturing & Production',
      description: 'Plan production, track raw materials, and cut down on wastage on the shop floor.',
      color: '#f2994a',
    },
    {
      image: 'images/mobilizers/hims.png',
      title: 'Healthcare',
      description: 'Run clinics and hospitals with patient records, billing, and inventory in sync.',
      color: '#eb5c6f',
    },
    {
      image: 'images/mobilizers/school.png',
      title: 'Education',
      description: 'Manage admissions, fees, and staff for schools from a single dashboard.',
      color: '#8a63d2',
    },
    {
      image: 'images/webps/inventory.svg',
      title: 'Multi-branch & Franchise',
      description: 'Get live visibility across every branch, with one set of books for the whole business.',
      color: '#3758a7',
    },
    {
      image: 'images/webps/procurement.svg',
      title: 'Services & Distribution',
      description: 'Coordinate procurement, suppliers, and delivery without switching between tools.',
      color: '#2fb380',
    },
  ];

  @ViewChildren('flowItem') private flowItems!: QueryList<ElementRef<HTMLElement>>;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId) || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    this.flowItems.forEach((item) => observer.observe(item.nativeElement));
  }
}
